import { SortInput } from '@apeiron/common'
import { PlanetFilterInput, PlanetSortBy } from '@apeiron/planet'
import { OthersFilterSection } from '@src/components/planet/filter/OthersFilterSection'
import PlanetBirthSkillElementFilter from '@src/components/planet/filter/PlanetBirthSkillElementFilter'
import PlanetClassAndTypeFilter from '@src/components/planet/filter/PlanetClassAndTypeFilter'
import PlanetElementFilter from '@src/components/planet/filter/PlanetElementFilter'
import PlanetSaveFilter from '@src/components/planet/filter/PlanetSaveFilter'
import PlanetCardSkillFilter from '@src/components/planet/filter/skillFilter/PlanetCardSkillFilter'
import PlanetPerkSkillFilter from '@src/components/planet/filter/skillFilter/PlanetPerkSkillFilter'
import { StatsFilterSection } from '@src/components/planet/filter/StatsFilterSection'
import { FeatureFlagType } from '@src/constants/featureFlag'
import featureAllowed from '@src/util/apeiron/featureAllowed'
import { toLayoutFilter } from '@src/util/apeiron/planetList'
import { FC, useCallback, useMemo } from 'react'

const PlanetFilter: FC<Props> = (props: Props) => {
  const {
    allowSave = true,
    isLoggedIn,
    filterInput,
    sortInput,
    onFilterInputChange,
    onFilterByFavorite
  } = props

  const filter = useMemo(() => toLayoutFilter(filterInput), [filterInput])

  const handleOnFilter = useCallback(
    (input: PlanetFilterInput) => {
      onFilterInputChange(input)
    },
    [onFilterInputChange]
  )

  return (
    <>
      {allowSave && isLoggedIn && (
        <PlanetSaveFilter
          filterOptions={filter}
          sortInput={sortInput}
          onFilterByFavorite={onFilterByFavorite}
        />
      )}
      <PlanetClassAndTypeFilter
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
      <PlanetCardSkillFilter
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
      <PlanetPerkSkillFilter
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
      <PlanetBirthSkillElementFilter
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
      <PlanetElementFilter
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
      {featureAllowed(FeatureFlagType.ShowPlanetStat) && (
        <StatsFilterSection
          filterOptions={filter}
          onFilterOptionsChange={handleOnFilter}
        />
      )}
      <OthersFilterSection
        filterOptions={filter}
        onFilterOptionsChange={handleOnFilter}
      />
    </>
  )
}

type Props = {
  allowSave?: boolean
  isLoggedIn?: boolean
  filterInput: PlanetFilterInput
  sortInput: SortInput<PlanetSortBy>
  onFilterInputChange: (input: PlanetFilterInput) => void
  onFilterByFavorite?: (
    input: PlanetFilterInput,
    sortInput: SortInput<PlanetSortBy>
  ) => void
}

export default PlanetFilter
